import Icon, {iconNames} from '@/components/01_Atoms/Icons/Icon.vue';

export default Icon;
export {iconNames};
